import { lazy, Suspense, Component } from "react";
import { Route, Switch } from "react-router-dom";

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, NavItem, Button } from 'react-bootstrap';
import IdleTimer from 'react-idle-timer'
import './App.scss';
import AuthContext from './Auth/AuthContext';
import Authentication from "./Auth/Authentication";
import Header from './Common/_components/Header';
import Login from './Login/Login';
  import PrivateRoute from "./Common/_components/PrivateRoute";
import { Loader } from "./Common/_components/Loader";
import { JwtInterceptor } from "./Common/_interceptors/JwtInterceptor";
import {SessionModal} from "./Common/modal/SessionModal";
import { LoginService } from "./Common/_services/login.service";
import { Toastify } from "./Common/_components/Toastify";
import { Modal } from "react-bootstrap";
import NotifyProvider, {NotifyContext} from "./CustomNotification/NotifyContext";
//import LabManualApproveGrid from "./OneLab/Dashboard/LabManualApproveGrid";

const iconPath = process.env.PUBLIC_URL + '/icons/';

//Dynamic imports for lazy loading
const Dashboard = lazy(() => import('./Dashboard/Dashboard'));
const Callback = lazy(() => import('./Common/_components/Callback'));

const Survey = lazy(() => import('./Survey/SurveyDashboard/Survey'));
const AddSurvey = lazy(() => import('./Survey/AddSurvey'));
const AddNews = lazy(() => import('./News/NewsCrud/AddNews'));
const AddVideo = lazy(() => import('./Video/VideoCrud/AddVideo'));
const AdminTool = lazy(() => import('./AdminTool/AdminTool'));
const Unauthorized = lazy(() => import('./Common/_components/Unauthorized'));

const AddQuestion = lazy(() => import('./Survey/AddQuestions'));
const surveyResult = lazy(() => import('./Survey/SurveyResult'));
const surveyView = lazy(() => import('./Survey/SurveyView/SurveyView'));
const CustomNotification = lazy(() => import('./CustomNotification/CustomNotification'));
const News = lazy(() => import('./News/Dashboard/News'));
const Video = lazy(() => import('./Video/Dashboard/Video'));
const ViewNews = lazy(() => import('./News/NewsCrud/ViewNews'));
const ViewVideo = lazy(() => import('./Video/VideoCrud/ViewVideo'));
const Cafe = lazy(() => import('./Cafe/Dashboard/ListCafeDetails'))
const CafeHealth = lazy(() => import('./CafeHealth/Dashboard/ListCafeHealthDetails'))
const Policy = lazy(() => import('./Policy/Dashboard/PolicyDetails'))
const AnalyticsDashboard = lazy(() => import('./Analytics/Dashboard/AnalyticsDashboard'));
const Deeplinking = lazy(() => import('./Deeplinking/Dashboard/ListActive'))
const Flags = lazy(() => import('./Flags/Dashboard/ListFlags'))
const CreateSeries = lazy(() => import('./SpinWin/SpinCrud/CreateSeries'))
const ListSpinSeries = lazy(() => import('./SpinWin/Dashboard/ListSpinSeries'))
const ViewSeries = lazy(() => import('./SpinWin/SpinCrud/ViewSeries'));
const ViewLab = lazy(()=>import('./OneLab/Dashboard/LabDetails'));
const ViewMap = lazy(()=>import('./OneLab/Dashboard/ListMap'));
const LabManual = lazy(() => import('./OneLab/Dashboard/LabManual'));
const ViewManualApproveGrid = lazy(() => import('./OneLab/Dashboard/LabManualApproveGrid'));
const ListLabManual = lazy(() => import('./OneLab/Dashboard/ListLabManual'));
const AuditChecklist  = lazy(() => import('./OneLab/Dashboard/AuditChecklist'));
const AuditSchedule = lazy(() => import('./OneLab/Dashboard/AuditSchedule'));
const InventoryReport = lazy(() => import('./OneLab/Dashboard/InventoryReport'));
const AuditCheckListDownload = lazy(() => import('./OneLab/Dashboard/AuditCheckListDownload'));
const TrainingCalendar = lazy(() => import('./OneLab/Dashboard/TrainingCalendar'));
const PageButtons = lazy(() => import('./OneLab/Dashboard/PageButtons'));
const ListAuditChecklist = lazy(() => import('./OneLab/Dashboard/ListAuditChecklist'));
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: new Authentication(props.history),
      isVisible: false,
      loadRoutes: false,
      loading: false,
      timeout:1000 * 60 * 29,
      showModal: false,
      showModal1: false,
      userLoggedIn: false,
      isTimedOut: false,
      showLayout:false,
      errorMsg:[],
      toastState: 0
    }
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.trigger = this.trigger.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.logOut = this.logOut.bind(this)
    this.handleRemoveMsg = this.handleRemoveMsg.bind(this)
  //  const test = useSharedNotes();
var test1 = LoginService.getSubject()

  test1.subscribe(data=>{
    console.log(data)
 
    if(data=="1"){
     
      LoginService.setSubject("ssssssss")
      this.setState({errorMsg:{id: Math.random(), type: "SUCCESS", message: "Notification is sent successfully" }});
    }
  })

  }
  _onAction(e) {
   // console.log('user did something', e)
    this.setState({isTimedOut: false})
  }
 
  _onActive(e) {
  //  console.log('user is active', e)
    this.setState({isTimedOut: false})
  }

  _onIdle(e) {
   // console.log('user is idle', e)
    this.setState({'showModal1':true});
    const isTimedOut = this.state.isTimedOut
    if (isTimedOut) {
       
    } else {
      this.setState({showModal: true})
      this.idleTimer.reset();
      this.setState({isTimedOut: true})
    }
    
  }

 async  trigger(){
    this.setState({"showModal1":false});
    this.setState({ loading: true });
    localStorage.setItem("loginTime", Date.now());
    try {
    const rs = await LoginService.getRefreshToken();
 
    localStorage.setItem('access_token',rs.access_token);
    localStorage.setItem('refresh_token',rs.refresh_token);
    localStorage.setItem("loginTime", Date.now());
    }catch(error){
      console.log(error);
    }finally{
      this.setState({ loading: false });
    }
 
 
   
  }
  logOut(){
    const { auth } = this.state;
    auth.logout();
    
  
  }
  updateModal(isVisible) {
    this.setState({
      isVisible: isVisible
    })
    this.forceUpdate();
  }
  

   getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

 dec2hex(dec) {
  return ("0" + dec.toString(16)).substr(-2);
}
generateCodeVerifier() {
  var array = new Uint32Array(56 / 2);
  window.crypto.getRandomValues(array);
  return Array.from(array, this.dec2hex).join("");
}

sha256(plain) {
  // returns promise ArrayBuffer
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest("SHA-256", data);
}
 generateRandomString() {
  var array = new Uint32Array(56/2);
  window.crypto.getRandomValues(array);
  return Array.from(array, this.dec2hex).join('');
}


base64urlencode(a) {
  var str = "";
  var bytes = new Uint8Array(a);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

async  generateCodeChallengeFromVerifier(v) {
  var hashed = await this.sha256(v);
  var base64encoded = this.base64urlencode(hashed);
  return base64encoded;
}

// handleRemoveMsg(id) {

// }


 loginToSSO(){
   localStorage.clear();
   window.location.href = `${process.env.REACT_APP_SSO_LOGIN_BASE_URL}/as/authorization.oauth2?response_type=code&client_id=${process.env.REACT_APP_SSO_CLIENT_ID}&scope=openid%20offline_access&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}`;
 }


  async componentDidMount() {
 
  
    this.setState({ loading: true });
    const { auth } = this.state;
    
   
    var codeVarifier = this.generateCodeVerifier();
    var codeChallender = await this.generateCodeChallengeFromVerifier(codeVarifier);

   
    const params = new URLSearchParams(window.location.search);
    const authCode = params.get('code'); 
    JwtInterceptor();
   
    if(this.getParameterByName('code')==null && !(localStorage.getItem('isLoggedIn')))
    {
     
      this.loginToSSO();
      
    }else{
   
      localStorage.setItem('isLoggedIn',true);
  
    
    //  window.history.replaceState(null, "New Page Title", "/pathname/goes/here")

  /*localStorage.setItem('access_token',"gb2Gio/VQy9AhkkpZgujiQ8spfxaONFBkxv9CLMXofk=");
      localStorage.setItem('userId',"VNAYAKM");
      localStorage.setItem('refresh_token',"nHPUvW1nPYUc/C/TXMPtRdigDbj0WjX/6YsKescIGBa89QqeCfm0ZN5FD3MXCDuN");
      //localStorage.setItem("urlAllowed","dashboard,oneLab,editrole")
  */
   //

  if(localStorage.getItem('isInDashboard')==null){
            if(this.getParameterByName('code')==null){

            
                  this.loginToSSO();
            }else{
              let response = await LoginService.getToken(this.getParameterByName('code'));
              // console.log(response)
              localStorage.setItem('access_token',response.access_token);
              localStorage.setItem('userId',response.shortId);
              localStorage.setItem('refresh_token',response.refresh_token);
              
            }
    

          }

    
      if(localStorage.getItem('isInDashboard')==null){
        localStorage.setItem("isLoggedInFirstTime", true);
        localStorage.setItem("loginTime", Date.now());
        localStorage.setItem("isInDashboard",true)
      //  this.props.history.push("/dashboard");  

       //window.history.replaceState(null, "New Page Title", "/dashboard")
       window.location.href = `${process.env.REACT_APP_DASHBOARD}`
    
      }else{
            let loginTime = localStorage.getItem('loginTime');
            let currentTime = Date.now();
            let timeDifference = (currentTime-loginTime)/1000/60;
          
            if(timeDifference>29){
              localStorage.clear();
                      
              this.loginToSSO();
            }else{
                if(this.props.history.location.pathname=="/"){
                
                  this.props.history.push("/dashboard"); 
                }
          }
      }
     
    
    
     let loginTime = localStorage.getItem('loginTime');
     let currentTime = Date.now();
     let timeDifference = (currentTime-loginTime)/1000/60;
    
     if(timeDifference>29){
      localStorage.clear();
       
      this.loginToSSO();
     }
     this.setState({'showLayout':true})
    }
 
    JwtInterceptor();
 
   // return false;
    // await auth.renewToken();
    try {
      
      this.setState({ loading: true });
    
      let userDetails = await auth.getUserDetailsById();
      //console.log("userDetails",userDetails.urlAllowed)
      localStorage.setItem('urlAllowed',userDetails.urlAllowed);
      if (userDetails) {
       
        auth.setRoleInfo(userDetails);
        if (this.props.history.location.pathname.includes("unauthorized"))
          this.props.history.push("/dashboard");
        // Load routes only when role related information is received , if not reroute to unauthorized screen. THis will prevent the routes to be loaded before role api is success
        // this.setState({
        //   loadRoutes: true
        // })
      }
    } catch (error) {
      if (auth.authResult && auth.authResult.userId) {
        this.props.history.push("/unauthorized");
      }
    } finally {
      //hide loader 
      this.setState({ loading: false });
    }
  }
   handleRemoveMsg(errorMsgId) {
    this.setState({errorMsg:this.state.errorMsg.filter(el => el.id !== errorMsgId)});
}

  render() {
    const toastStyle = {
      position: "absolute",
      top: "45%", // computed based on child and parent's height
      left: "35%",
      zIndex: "10"
    };
    const { auth, loadRoutes, loading,showModal1,showLayout,errorMsg,handleRemoveMsg } = this.state;
    return (
      <div className="App">
  
        { <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
        timeout={this.state.timeout} />}
        {/* sample login
        {auth.isAuthenticated() ? null : <button onClick={auth.login}>login</button>}
        <Button bsStyle="primary" onClick={ () => this.updateModal(true) }></Button>
        */}

        {showLayout &&
        <div className="container-fluid">
        <SessionModal show={showModal1} logOut={this.logOut} title="" message="Do you want to Continue Session?" actionlabel="Yes" onUpdateToParent={this.trigger} type={'delete'} />
          {loading ? <Loader /> : ""}
          <AuthContext.Provider value={auth}>
          <NotifyProvider>
          <NotifyContext.Consumer>
                {({getToastState,toast,getResponse,toastVal})=>{
                  console.log("toast",toast,toast.length>0);
                  return(
                    <>
            <Header auth={auth} {...this.props} />        
            <div className="center-content">
                    <div style={toastStyle}>  
                    {toast.length>0&&<Toastify key={1} show={true} errorMsg={{ id: Math.random(), type: "SUCCESS", message: "Notification is sent successfully" }} removeMsg={this.handleRemoveMsg} />}                   
                  
            </div>
              {/* Lazy loading implementation */}
              <Suspense fallback={<p>Component is loading. Please wait..</p>}>
                <Switch>
                  {/* {loadRoutes ? */}
                  {/* <> */}
                  <PrivateRoute path="/dashboard"  component={Dashboard} scopes={["dashboard"]} />
                  <Route path="/callback" render={props => <Callback auth={auth} {...props} />} />
                  <PrivateRoute path="/survey" component={Survey} scopes={["survey"]} />
                  <PrivateRoute path="/addSurvey" component={AddSurvey} scopes={["survey"]} />
                  <PrivateRoute exact path="/surveyDetails/:surveyId" component={AddSurvey} scopes={["survey"]} />
                  <Route path="/unauthorized" component={Unauthorized} />
                  <Route path="/configtool/:config" component={AdminTool} scopes={["configtool"]} />
                  <PrivateRoute path="/addQuestion" component={AddQuestion} scopes={["survey"]} />
                  <PrivateRoute path="/surveyResults/:surveyId" component={surveyResult} scopes={["survey"]} />
                  <PrivateRoute path="/surveyView/:surveyId" component={surveyView} scopes={["survey"]} />
                  <Route path="/emergencyNotification" render={() => <CustomNotification getResponse={getResponse} toastVal={toastVal}/>}  scopes={["notification"]}/>
                  <PrivateRoute path="/News" component={News} scopes={["news"]} />
                  <Route path="/addNews" component={AddNews} scopes={["news"]} />
                  <Route path="/newsDetails/:newsId" component={AddNews} />
                  <Route path="/viewNews/:newsId" component={ViewNews} scopes={["news"]} />

                  <PrivateRoute path="/Video" component={Video} scopes={["video"]} />
                  <Route path="/addVideo" component={AddVideo} scopes={["video"]} />
                  <Route path="/videoDetails/:videoId" component={AddVideo} />
                  <Route path="/viewVideo/:videoId" component={ViewVideo} scopes={["video"]} />
                  <PrivateRoute
                      path='/cafe'
                      component={Cafe}
                      scopes={['cafe']}
                    />
                     <PrivateRoute
                      path='/cafeHealth'
                      component={CafeHealth}
                      scopes={['cafe']}
                    />
                    <PrivateRoute
                      path='/policy'
                      component={Policy}
                      scopes={['policy']}
                    />
                    <PrivateRoute
                      path='/deeplinking'
                      component={Deeplinking}
                      scopes={['deeplinking']}
                    />
                     <PrivateRoute
                      path='/flags'
                      component={Flags}
                      scopes={['flags']}
                    />
                     <Route
                      path='/createSeries'
                      component={CreateSeries}
                      scopes={['spinandwin']}
                    />
                 <PrivateRoute path="/LabManual" component={LabManual} scopes={["oneLab"]} />
                 <PrivateRoute path="/labManualDetails/:labNumber/:dept/:versionNo" component={LabManual} scopes={["oneLab"]} />
              <PrivateRoute path="/ListLabManual" component={ListLabManual} scopes={["oneLab"]} />
                  <Route path="/editSeries/:seriesId" component={CreateSeries} />
                  <Route path="/viewSeries/:seriesId" component={ViewSeries} scopes={["news"]} />
                      <PrivateRoute
                      path='/listSpinSeries'
                      component={ListSpinSeries}
                      scopes={['spinandwin']}
                    />
                     <PrivateRoute path="/ListLabs" component={PageButtons} scopes={["oneLab"]} />
                     <PrivateRoute path="/ViewLabs" component={ViewLab} scopes={["oneLab"]} />

                    <PrivateRoute path="/ListMaps" component={ViewMap} scopes={["oneLab"]} />
                    <Route path="/LabManualApproveGrid" component={ViewManualApproveGrid} scopes={["oneLab"]} />
                    <Route path="/AuditChecklist" component={AuditChecklist} scopes={["oneLab"]} />
                    <Route path="/AuditSchedule" component={AuditSchedule} scopes={["oneLab"]} />
                    <Route path="/InventoryReport" component={InventoryReport} scopes={["oneLab"]} />
                    <Route path="/AuditDownload" component={AuditCheckListDownload} scopes={["oneLab"]} />
                    <Route path="/Training" component={TrainingCalendar} scopes={["oneLab"]} />
                    <Route path="/PageButtons" component={PageButtons} scopes={["oneLab"]} />
                    <Route path="/ListAuditChecklist" component={ListAuditChecklist} scopes={["oneLab"]} />
                    <PrivateRoute path="/AuditChecklistDetails/:labNumber/:versionNo" component={AuditChecklist} scopes={["oneLab"]} />
                  <Route
                    path="/analytics"
                    render={({ match: { url } }) => (
                      <>
                        <Route path={`${url}/dashboard`} component={AnalyticsDashboard} scopes={["analytics"]} />
                      </>
                    )}
                  />
                
                  {/* </> */}
                  {/* : ""} */}
                </Switch>
              </Suspense>
            </div>
              <div className="center-content">
              <Suspense fallback={<p>Component is loading. Please wait..</p>}>
                <Switch>
                  <PrivateRoute path="/dashboard"  component={Dashboard} scopes={["dashboard"]} />
                  <Route path="/callback" render={props => <Callback auth={auth} {...props} />} />
                  <PrivateRoute path="/survey" component={Survey} scopes={["survey"]} />
                  <PrivateRoute path="/addSurvey" component={AddSurvey} scopes={["survey"]} />
                  <PrivateRoute exact path="/surveyDetails/:surveyId" component={AddSurvey} scopes={["survey"]} />
                  <Route path="/unauthorized" component={Unauthorized} />
                  <Route path="/configtool/:config" component={AdminTool} scopes={["configtool"]} />
                  <PrivateRoute path="/addQuestion" component={AddQuestion} scopes={["survey"]} />
                  <PrivateRoute path="/surveyResults/:surveyId" component={surveyResult} scopes={["survey"]} />
                  <PrivateRoute path="/surveyView/:surveyId" component={surveyView} scopes={["survey"]} />
                  <Route path="/emergencyNotification" render={() => <CustomNotification getResponse={getResponse} toastVal={toastVal} />}  scopes={["notification"]}/>
                  {/* <Route path="/emergencyNotification" value={"ff"} component={CustomNotification} scopes={["notification"]} /> */}
                  <PrivateRoute path="/News" component={News} scopes={["news"]} />
                  <Route path="/addNews" component={AddNews} scopes={["news"]} />
                  <Route path="/newsDetails/:newsId" component={AddNews} />
                  <Route path="/viewNews/:newsId" component={ViewNews} scopes={["news"]} />

                  <PrivateRoute path="/Video" component={Video} scopes={["video"]} />
                  <Route path="/addVideo" component={AddVideo} scopes={["video"]} />
                  <Route path="/videoDetails/:videoId" component={AddVideo} />
                  <Route path="/viewVideo/:videoId" component={ViewVideo} scopes={["video"]} />
                  <PrivateRoute path="/LabManual" component={LabManual} scopes={["oneLab"]} />
                  <PrivateRoute path="/labManualDetails/:labNumber/:dept/:versionNo" component={LabManual} scopes={["oneLab"]} />
                    <PrivateRoute path="/ListLabManual" component={ListLabManual} scopes={["oneLab"]} />
                   <Route path="/LabManualApproveGrid" component={ViewManualApproveGrid} scopes={["oneLab"]} />
                  <PrivateRoute
                      path='/cafe'
                      component={Cafe}
                      scopes={['cafe']}
                    />
                    <PrivateRoute
                      path='/policy'
                      component={Policy}
                      scopes={['policy']}
                    />
                    <PrivateRoute
                      path='/deeplinking'
                      component={Deeplinking}
                      scopes={['deeplinking']}
                    />
                     <PrivateRoute
                      path='/flags'
                      component={Flags}
                      scopes={['flags']}
                    />
                     <Route
                      path='/createSeries'
                      component={CreateSeries}
                      scopes={['flags']}
                    />
                  {/*<PrivateRoute path="/ListLabs" component={ViewLab} scopes={["oneLab"]} />*/}

                    <PrivateRoute path="/ListMaps" component={ViewMap} scopes={["oneLab"]} />
                    <Route path="/LabManualApproveGrid" component={ViewManualApproveGrid} scopes={["oneLab"]} />
                  <Route path="/editSeries/:seriesId" component={CreateSeries} />
                  <Route path="/viewSeries/:seriesId" component={ViewSeries} scopes={["news"]} />
                      <PrivateRoute
                      path='/listSpinSeries'
                      component={ListSpinSeries}
                      scopes={['flags']}
                    />
                  <Route
                    path="/analytics"
                    render={({ match: { url } }) => (
                      <>
                        <Route path={`${url}/dashboard`} component={AnalyticsDashboard} scopes={["analytics"]} />
                      </>
                    )}
                  />
                
                  {/* </> */}
                  {/* : ""} */}
                </Switch>
              </Suspense>
            </div>
            </>
            )}}
            </NotifyContext.Consumer>
            </NotifyProvider>
          </AuthContext.Provider>
        </div>
        }
      </div>
    );
  }
}

export default App;